import qs from 'qs';
import store from '../store';

/**
 * 知识库问答对接API
 */
export default {
    /**
     * 知识库树
     */
    async getCatalogTree () {
        let token = store.state.account.token;
        const API = '/call-platform/knowledgeCatalog/getTree';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 知识库树
     */
    async getKnowledgePage (payload) {
        let token = store.state.account.token;
        if (!payload) payload = {};
        if (!payload.pageNo)payload.pageNo = 1;
        var params = qs.stringify(payload);
        const API = '/call-platform/knowledge/page?' + params;
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 知识库树
     */
    async getKnowledge (knowledgeId) {
        let token = store.state.account.token;
        const API = '/call-platform/knowledge/get?knowledgeId=' + knowledgeId;
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 增加目录
     */
    async addCatalog (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/knowledgeCatalog/add';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'POST', headers, body: JSON.stringify(payload) });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 更新目录
     */
    async updateCatalog (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/knowledgeCatalog/update';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'POST', headers, body: JSON.stringify(payload) });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 删除目录
     */
    async deleteCatalog (catIds) {
        let token = store.state.account.token;
        const API = '/call-platform/knowledgeCatalog/delete?catIds=' + catIds;
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'POST', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 增加知识库
     */
    async addKnowledge (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/knowledge/add';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'POST', headers, body: JSON.stringify(payload) });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 更新知识库
     */
    async updateKnowledge (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/knowledge/update';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'POST', headers, body: JSON.stringify(payload) });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 删除知识库
     */
    async deleteKnowledge (knowledgeIds) {
        let token = store.state.account.token;
        const API = '/call-platform/knowledge/delete?knowledgeIds=' + knowledgeIds;
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    }
};
